/**
 * @generated SignedSource<<c569991e5fc8cf0c2b9aa64034631fad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectSlackTooltipFragment$data = {
  readonly viewerMembership: {
    readonly organizationMembershipSlackConnection: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentType": "ConnectSlackTooltipFragment";
};
export type ConnectSlackTooltipFragment$key = {
  readonly " $data"?: ConnectSlackTooltipFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectSlackTooltipFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectSlackTooltipFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipSlackConnection",
          "kind": "LinkedField",
          "name": "organizationMembershipSlackConnection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "4b623c89cd2ad8dab43121d925bc629c";

export default node;
